import {
  ExperienceDto,
  RequiredExperienceType,
  VariationDto,
} from "@intelligems/ig-types";

export const filterExperiences = (
  experiments: ExperienceDto[],
  filter: "control" | "nonControl"
) => {
  const groupWinners: ExperienceDto[] = [];
  const controlWinners: ExperienceDto[] = [];

  experiments.forEach((exp: ExperienceDto) => {
    const controlGroup = exp.variations.find((exp) => exp.isControl);
    const impactGroup = exp.variations.find(
      (variation) =>
        variation.id === exp.experienceAnalysis.impactWinnerVariationId
    );
    if (controlGroup && impactGroup) {
      if (controlGroup.id === impactGroup.id) {
        controlWinners.push(exp);
      } else {
        groupWinners.push(exp);
      }
    }
  });

  if (filter === "control") {
    return controlWinners;
  } else {
    return groupWinners;
  }
};
